export const currencyFormatting = ({ value, currency, format }) =>
  new Intl.NumberFormat(format || "us-US", {
    style: "currency",
    currency: currency || "IDR",
    minimumFractionDigits: 0,
  }).format(value || 0);

export const numberFormatting = ({ value, format }) =>
  new Intl.NumberFormat(format || "us-US", {
    minimumFractionDigits: 0,
  }).format(value || 0);

export const applyMask = (value = "", mask) => {
  const cleanValue = value.replace(/\W/g, "");
  let result = "";
  let valueIndex = 0;

  for (let i = 0; i < mask.length; i++) {
    if (valueIndex >= cleanValue.length) break;

    if (mask[i] === "0") {
      result += cleanValue[valueIndex++];
    } else {
      result += mask[i];
    }
  }

  return result;
};
export const MASKS = {
  NPWP: "00.000.000.0-000.000",
  NIK: "0000000000000000",
  PHONE: "0000-0000-0000",
  CREDIT_CARD: "0000 0000 0000 0000",
};
export const formatNpwp = (value = "") => {
  const digits = value.replace(/\D/g, "").slice(0, 16);

  if (digits.length === 16) {
    return digits;
  }

  return applyMask(digits, MASKS.NPWP);
};
export default {
  currencyFormatting,
  numberFormatting,
  applyMask,
  formatNpwp,
};
